import safeLocalStorage from 'safe-localstorage';

export function clearMapPlaces(state) {
  state.mapPlacesSearchResults = [];
}

export function setSearchType(state, type) {
  state.searchType = type;
}

export function setHistory(state, history) {
  state.history = history;
  safeLocalStorage.set('search/history', JSON.stringify(history));
}

export function setMapPlacesSearchLoading(state, isLoading) {
  state.mapPlacesSearchLoading = isLoading;
}

export function setMapPlacesSearchResults(state, results) {
  state.mapPlacesSearchResults = results;
}

export function setSearchItems(state, items) {
  state.searchItems = items;
}

export function setSelectedExternalAddressIndex(state, index) {
  state.selectedExternalAddressIndex = index;
}

export function setFilterTerms(state, terms) {
  state.filterTerms = terms;
}
